import Vue from 'vue'

const defaultState = {
  config: undefined,
  index: undefined,
  authorized: undefined,
  homeDirectory: undefined,
  requestedPlan: undefined,
  roles: [
    {
      label: 'roles.admin',
      value: 'admin',
    },
    {
      label: 'roles.user',
      value: 'user',
    },
  ],
  sorting: {
    sort: localStorage.getItem('sorting')
      ? JSON.parse(localStorage.getItem('sorting')).sort
      : 'DESC',
    field: localStorage.getItem('sorting')
      ? JSON.parse(localStorage.getItem('sorting')).field
      : 'created_at',
  },
}
const actions = {}
const mutations = {
  INIT(state, data) {
    state.config = data.config
    //state.authorized = data.authCookie
    state.homeDirectory = data.rootDirectory
  },
  SET_AUTHORIZED(state, data) {
    state.authorized = data
  },
  SET_INDEX_CONTENT(state, data) {
    state.index = data
  },
}
const getters = {
  homeDirectory: (state) => state.homeDirectory,
  requestedPlan: (state) => state.requestedPlan,
  currencyList: (state) => state.currencyList,
  countries: (state) => state.countries,
  timezones: (state) => state.timezones,
  api: (state) =>
    state.config ? state.config.api : Vue.prototype.$app.appUrlClientApi,
  config: (state) => state.config,
  emojis: (state) => state.emojis,
  index: (state) => state.index,
  roles: (state) => state.roles,
  sorting: (state) => {
    return {
      sorting: state.sorting,
      URI: '?sort=' + state.sorting.field + '&direction=' + state.sorting.sort,
    }
  },
}

export default {
  state: defaultState,
  getters,
  actions,
  mutations,
}
